/* /hotels: the area chips over the map, the map's placeholder, the area cards. */

/* Pills like the events filters: outlined, filled in the brand brown when on. */
.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 16px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  background: var(--card);
  color: var(--text);
  font: 500 14px var(--font-body);
  cursor: pointer;
}

.chip:hover {
  border-color: var(--primary);
}

.chip[aria-pressed='true'] {
  border-color: var(--primary);
  background: var(--primary);
  color: #ffffff;
}

/* Holds the map's place (and height) until the visitor opens it. */
.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  height: 480px;
  margin: 0 0 32px;
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--band);
  color: var(--label);
  text-align: center;
  box-sizing: border-box;
}

.placeholder p {
  max-width: 460px;
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.primary {
  display: inline-flex;
  align-items: center;
  height: 52px;
  padding: 0 36px;
  border: 0;
  border-radius: var(--radius-pill);
  background: var(--primary);
  color: #ffffff;
  font: 500 15px var(--font-body);
  cursor: pointer;
}

.primary:hover {
  background: var(--primary-hover);
}

.allLine {
  margin: -12px 0 0;
}

/* Outlined, as the "See hotels" of the event pages. */
.secondary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 48px;
  padding: 0 26px;
  border: 1px solid var(--primary);
  border-radius: var(--radius-pill);
  background: var(--card);
  color: var(--primary);
  font: 500 15px var(--font-body);
  cursor: pointer;
}

.secondary:hover {
  background: var(--band);
}

.areas {
  display: grid;
  gap: 20px;
}

.area {
  padding: 24px;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--card);
  scroll-margin-top: 16px;
}

.areaName {
  margin: 0 0 8px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 27px;
  line-height: 1.1;
}

.bestFor {
  margin: 0 0 12px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-body);
}

.bestFor span {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--label);
}

.text {
  margin: 0 0 10px;
  font-size: 15px;
  line-height: 1.7;
  color: var(--text-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 22px;
  margin-top: 16px;
}

.link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--text);
  font: 500 14px var(--font-body);
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 4px;
  cursor: pointer;
}

@media (max-width: 767px) {
  .placeholder {
    height: 360px;
  }

  .area {
    padding: 20px;
  }
}

@media (min-width: 1024px) {
  .areas {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
  }
}
